/**
 * Phase 46 (2026-07-29) - Bridge between DashboardPage and the shared AppLayout top-bar.
 *
 * DashboardPage exposes `{ refresh, refreshing, lastUpdated }` via `useDashboardActions`.
 * AppLayout's top bar reads it and only renders the compact date/clock/refresh cluster
 * when the current page has registered actions.
 */
import { createContext, useContext, useState, useCallback, useMemo } from "react";

const DashboardActionsContext = createContext(null);

export function DashboardActionsProvider({ children }) {
  const [state, setState] = useState({
    refresh: null,
    refreshing: false,
    lastUpdated: null,
  });

  const register = useCallback((next) => {
    setState((prev) => ({ ...prev, ...next }));
  }, []);

  const clear = useCallback(() => {
    setState({ refresh: null, refreshing: false, lastUpdated: null });
  }, []);

  const value = useMemo(() => ({ ...state, register, clear }), [state, register, clear]);
  return (
    <DashboardActionsContext.Provider value={value}>
      {children}
    </DashboardActionsContext.Provider>
  );
}

export function useDashboardActions() {
  const ctx = useContext(DashboardActionsContext);
  if (!ctx) return { refresh: null, refreshing: false, lastUpdated: null, register: () => {}, clear: () => {} };
  return ctx;
}
